import * as styles from './ProductsCompareModalHeaderRow.module.scss';

interface Props {
  title: string;
  // offsets its top position when stickied to top
  // useful when something else is stickied above it and you don't want them to overlap
  headerOffset: number;
}

const ProductsCompareModalHeaderRow: React.FC<Props> = ({ title, headerOffset }) => {
  return (
    <tr className={styles.ProductsCompareModalHeaderRow} style={{ top: headerOffset }}>
      <td colSpan={100}>{title}</td>
    </tr>
  );
};

export default ProductsCompareModalHeaderRow;
